export function _googlemap(googlemapParams) {

    const renderMapParams = googlemapParams;

    function initMap() {
    const latlng = new google.maps.LatLng(
        renderMapParams.lat,
        renderMapParams.lng
    ); //中心の緯度, 経度
    const map = new google.maps.Map(
        document.getElementById(renderMapParams.element),
        {
        zoom: renderMapParams.zoom, //ズームの調整
        center: latlng, //上で設定した中心
        }
    );
    const marker = new google.maps.Marker({
        position: latlng,
        map: map,
    });
    }

    window.initMap = initMap;
}